// export const CUSTOM_SETTINGS = 'custom_settings';
// export const DEFAUL_FILTERS = 'filter_values';
// export const DEFAUL_FILTERS_STATUSES = 'filters_statuses';
// export const JOB_HISTORY = 'job_history';
export const OUTPUT_LANGUAGES = 'output_languages';
export const LANGUAGES = 'languages';
export const BRANDS = 'brands';
export const TARGET_COUNTRIES = 'target_countries';
export const CONTEXTS = 'contexts';
// export const OUTPUTS = 'outputs';
export const DRAFTS = 'drafts';
export const USER_SETTINGS = 'user_settings';
export const CONVERSATIONS = 'conversations';
export const POST_DEFAULT_LANGUAGES = 'post_default_languages';
export const USER_DEFAULT_FILTERS = 'user_default_filters';
export const DEFAULT_FILTERS = 'default_filters';
export const ADDITIONAL_SETTINGS = 'additional_settings';
export const SEARCH_HISTORY = 'search_history';
export const USER_SIGNATURES = 'signatures';
export const AUTH_WHITELIST = 'auth_whitelist';
export const ADMIN_USERS = 'admin_users';
export const INSTRUCTION_SUGGESTIONS = 'instruction_suggestions';
export const INSTRUCTION_HISTORY = 'instruction_history';
export const ADDITIONAL_SETTINGS_INSTRUCTION = 'additional_settings_instruction';
export const NEWS = 'news';
